import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { useState } from "react";
import { EmptyState, ErrorState, LoadingState } from "../../components/States";
import { logsApi } from "../../services/logsApi";
import { formatDateTime } from "../../utils/format";

function logMeta(technicalDetails: string, speed: string | null) {
  const eventId = technicalDetails.match(/elisaEventId=([^;]+)/)?.[1];
  const contractTerm = technicalDetails.match(/contractTerm=([^;]+)/)?.[1];
  return [speed, contractTerm, eventId].filter(Boolean).join(" · ") || "–";
}

export function LogsPage() {
  const query = useQuery({
    queryKey: ["logs"],
    queryFn: logsApi.list,
    refetchInterval: 5_000,
    refetchOnWindowFocus: true,
    staleTime: 0
  });
  const [search, setSearch] = useState("");
  const [severity, setSeverity] = useState("");
  const [expanded, setExpanded] = useState<string | null>(null);
  if (query.isLoading) return <LoadingState label="Ladataan tapahtumalokia…" />;
  if (query.isError) return <ErrorState />;
  const logs = query.data!.filter((log) =>
    (!severity || log.severity === severity) &&
    (!search || `${log.requestCode} ${log.message} ${log.eventType}`.toLowerCase().includes(search.toLowerCase()))
  );
  return (
    <>
      <section className="page-heading"><div><span className="kicker">YLLÄPITO</span><h1>Lokit ja virheet</h1><p>Työnkulun audit- ja virhetapahtumat.</p></div><span className="count-pill">{query.data!.length} tapahtumaa</span></section>
      <section className="card">
        <div className="filters"><label className="search-box"><Search size={18} /><input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Hae tunnuksella tai viestillä" /></label>
          <select value={severity} onChange={(e) => setSeverity(e.target.value)}><option value="">Kaikki vakavuudet</option><option value="info">Info</option><option value="warning">Varoitus</option><option value="error">Virhe</option></select>
        </div>
        {!logs.length ? <EmptyState title="Ei lokitapahtumia" text="Hakuehdoilla ei löytynyt tapahtumia." /> :
        <div className="log-list">{logs.map((log) => <button className={`log-row log-row--${log.severity}`} key={log.id} onClick={() => setExpanded(expanded === log.id ? null : log.id)}>
          <span className={`severity-dot severity-dot--${log.severity}`} /><time>{formatDateTime(log.timestamp)}</time>
          <span><strong>{log.requestCode}</strong><small>{logMeta(log.technicalDetails, log.speed)}</small></span><span className="event-type">{log.eventType}</span>
          <span className="log-message">{log.message}{expanded === log.id && <code>{log.technicalDetails}</code>}</span>
          <span className={`severity-label severity-label--${log.severity}`}>{log.severity === "info" ? "Info" : log.severity === "warning" ? "Varoitus" : "Virhe"}</span>
        </button>)}</div>}
      </section>
    </>
  );
}
